// extracted by mini-css-extract-plugin
export default {"topRow":"css_topRow__MrBO+","topRowOnlyConfigurator":"css_topRowOnlyConfigurator__EnRhC"};